import { render } from "./HomeKPI.vue?vue&type=template&id=51d27bf5&scoped=true"
import script from "./HomeKPI.vue?vue&type=script&lang=js"
export * from "./HomeKPI.vue?vue&type=script&lang=js"

import "./HomeKPI.vue?vue&type=style&index=0&id=51d27bf5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51d27bf5"

export default script